import { DEFAULT_TEAR_SHEET_CONTENT } from "@app/components/editor/workspace/golden-layout-definitions";

import { Component, ViewChild } from "@angular/core";
import { UserService } from "../../services/user.service";
import { User } from "../../data/user";
import { LoaderService } from "../../services/loader.service";
import { fadeInOutAnimation, savingButtonAnimation } from "../../animations";
import { ColorEvent } from "ngx-color";
import { ListingService } from "@app/services/listing.service";

import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { Angulartics2 } from "angulartics2";
import { FileService } from "@app/services/file.service";
import { ChangeDetectorRef } from "@angular/core";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { BaseEditorComponent } from "@app/components/platform/base-editor.component";
import { DomSanitizer } from "@angular/platform-browser";
import { CatalogService } from "@app/services/catalog.service";
import { Listing } from "@app/data/listing";

@Component({
  templateUrl: "./tear-sheet.component.html",
  animations: [fadeInOutAnimation, savingButtonAnimation],
})
export class TearSheetComponent extends BaseEditorComponent {
  @ViewChild("addToStoreSupermodal")
  addToStoreSupermodalComponent: SupermodalComponent;
  @ViewChild("addToStoreSupermodal") page: SupermodalComponent;

  keyword: string = "";
  buttonConfiguration = {
    text: "Download Tear Sheet",
    textColor: "#fff",
    backgroundColor: "#000",
    borders: "square",
    action: "download",
    emailRecipient: "",
  };

  buttonPreview: string;
  preview: string;
  buttonCode: string;

  constructor(
    private angulartics2: Angulartics2,
    sanitizer: DomSanitizer,
    catalogService: CatalogService,
    listingService: ListingService,
    userService: UserService,
    loaderService: LoaderService,
    fileService: FileService,
    changeDetectorRef: ChangeDetectorRef,
    goldenLayoutService: GoldenLayoutService
  ) {
    super(
      sanitizer,
      catalogService,
      listingService,
      userService,
      loaderService,
      fileService,
      changeDetectorRef,
      goldenLayoutService
    );
    this.field = "tear_sheet";
    this.angulartics2.eventTrack.next({ action: "Opened Tear Sheet Page" });
  }

  protected setUserModel(user: User) {
    user.tear_sheet = user.tear_sheet || {
      html: "",
      structure: DEFAULT_TEAR_SHEET_CONTENT,
    };
    user.tear_sheet.structure =
      user.tear_sheet.structure || DEFAULT_TEAR_SHEET_CONTENT;
    super.setUserModel(user);
  }

  buttonColorChanged(field, $event: ColorEvent) {
    this.buttonConfiguration[field] = $event.color.hex;
    this.updateButtonConfiguration();
  }

  updateButtonConfiguration() {
    if (this.user && this.listing) {
      var actionHTML = "";
      let url;
      let encodedUrl;
      url = `${this.documentURL}{{product.id}}`;
      encodedUrl = `${encodeURIComponent(this.documentURL)}{{product.id}}`;
      if (this.buttonConfiguration.action === "download") {
        actionHTML += `onclick="javascript: window.open('${url}')"`;
      } else if (this.buttonConfiguration.action === "sendEmail") {
        actionHTML += `onclick="javascript: window.location.href='mailto:${this.buttonConfiguration.emailRecipient}?subject=Tearsheet&body=${encodedUrl}'"`;
      }
      this.buttonCode = `<button style="padding: 4px 10px; 
          color: ${this.buttonConfiguration.textColor}; 
          background-color: ${this.buttonConfiguration.backgroundColor};
          border-radius:${
            this.buttonConfiguration.borders == "rounded" ? "4px" : 0
          }" ${actionHTML}>${this.buttonConfiguration.text}</button>`;
      this.buttonPreview = this.buttonCode.replace(
        "{{product.id}}",
        this.listing.id
      );
    }
  }

  addToStore() {
    this.angulartics2.eventTrack.next({ action: "Clicked on add to store" });

    this.submitDocument(false);
    this.updateButtonConfiguration();
    this.addToStoreSupermodalComponent.open();
  }

  protected initDocumentUrl(baseUrl: string) {
    this.documentURL = `${baseUrl}/tear-sheets?u=${this.userModel.hashId}&l=`;
  }

  protected initComponent() {
    super.initComponent();

    this.updateButtonConfiguration();
  }

  // protected getPDFURL():string {
  //   return ;
  // }

  protected download(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      resolve(`${this.documentURL}${this.listing.id}`);
    });
  }
}
